// extracted by mini-css-extract-plugin
export default {"container":"style_container__rkM9P","titleSection":"style_titleSection__bUqZM"};